import { render, staticRenderFns } from "./SGPDynamicImportComponent.vue?vue&type=template&id=1c487da6"
import script from "./SGPDynamicImportComponent.vue?vue&type=script&lang=js"
export * from "./SGPDynamicImportComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports